import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'backendSVG',
}) => (
  <svg
    viewBox="0 0 288 267.5"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M144,31.2c-57.6,0-104.4,13.1-104.4,29.2v146h1c6.6,14.4,50.3,25.5,103.4,25.5s96.8-11.1,103.4-25.5h0.1v-0.1
	c0.5-1.2,0.9-2.4,0.9-3.6V60.4C248.4,44.3,201.6,31.2,144,31.2z M144,96c-42.7,0-77.4-9.7-77.4-21.7s34.6-21.7,77.4-21.7
	s77.4,9.7,77.4,21.7S186.7,96,144,96z"
    />
  </svg>
);

export default SVG;
